import React, { useRef, useState } from "react";
import styles from "./Search.module.scss";
import { ReactSVG } from "react-svg";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import { getRelativePathFromLink } from "../../../utils/url";
import { FocusTrap } from "@aleksundshantu.com/aunds-utils-react/accessibility";
interface SearchProps {
  searchPageSlug: string;
}

export const Search = ({ searchPageSlug }: SearchProps) => {
  const [open, setOpen] = useState(false);
  const searchRef = useRef(null);
  const [searchPhrase, setSearchPhrase] = useState("");
  const { getIcon, getLabel } = useGlobalContext();
  searchPageSlug = searchPageSlug
    ? getRelativePathFromLink(searchPageSlug).replace(/\//g, "")
    : "search";

  const searchHandler = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      // router.push("/search?keyword=" + e.target.value);
      window.location.replace(`/${searchPageSlug}/?keyword=` + searchPhrase);
    }
  };

  return (
    <div
      data-isopen={open}
      className={`search-wrapper ${styles["search-wrapper"]}`}
    >
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <form
        onSubmit={(e) => e.preventDefault()}
        ref={searchRef}
        className={`${styles["searchbar"]} ${open ? styles["is-open"] : ""}`}
        onKeyUp={(e) => {
          if (e.key === "Escape") {
            setOpen(false);
          }
        }}
      >
        <ReactSVG
          src={getIcon("search")}
          width={24}
          height={24}
          wrapper={"svg"}
          className="is-hidden-after-navbar-breakpoint ml-4"
          beforeInjection={(svg) => {
            svg.setAttribute("alt", `Search Icon`);
            svg.setAttribute("aria-label", `Search Icon`);
          }}
        />
        <FocusTrap autoFocus disabled={!open}>
          <input
            className={styles["searchbar-input"]}
            name="searchbar"
            placeholder={getLabel("search_placeholder")}
            aria-label={getLabel("search_input_aria_label")}
            autoComplete="off"
            onChange={(e) => {
              setSearchPhrase(e.target.value);
            }}
            tabIndex={open ? 0 : -1}
            onKeyDown={(e) => searchHandler(e)}
          />
        </FocusTrap>
      </form>

      <button
        type="button"
        aria-expanded={open}
        onClick={() => {
          setOpen(!open);
        }}
        className={`${styles["searchbar-button"]} ${open ? styles["is-open"] : ""}`}
        aria-label={getLabel("arialabel_search_icon")}
        role="button"
      >
        {/* jscpd:ignore-start */}
        <ReactSVG
          src={getIcon("search")}
          width={24}
          height={24}
          wrapper={"svg"}
          role="link"
          aria-label="search"
          beforeInjection={(svg) => {
            svg.setAttribute("alt", `Search Icon`);
            svg.setAttribute("aria-label", `Search Icon`);
          }}
        />
        {/* jscpd:ignore-end */}
      </button>
    </div>
  );
};
